var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmployed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15986_21662)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55558 3.33337C4.17486 3.33337 3.05558 4.45266 3.05558 5.83337C3.05558 7.21409 4.17486 8.33337 5.55558 8.33337C6.93629 8.33337 8.05558 7.21409 8.05558 5.83337C8.05558 4.45266 6.93629 3.33337 5.55558 3.33337ZM4.72224 5.83337C4.72224 5.37314 5.09534 5.00004 5.55558 5.00004C6.01581 5.00004 6.38891 5.37314 6.38891 5.83337C6.38891 6.29361 6.01581 6.66671 5.55558 6.66671C5.09534 6.66671 4.72224 6.29361 4.72224 5.83337Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.66671C8.61931 6.66671 7.50002 7.786 7.50002 9.16671C7.50002 10.5474 8.61931 11.6667 10 11.6667C11.3807 11.6667 12.5 10.5474 12.5 9.16671C12.5 7.786 11.3807 6.66671 10 6.66671ZM9.16669 9.16671C9.16669 8.70647 9.53978 8.33337 10 8.33337C10.4603 8.33337 10.8334 8.70647 10.8334 9.16671C10.8334 9.62695 10.4603 10 10 10C9.53978 10 9.16669 9.62695 9.16669 9.16671Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9445 5.83337C11.9445 4.45266 13.0638 3.33337 14.4445 3.33337C15.8252 3.33337 16.9445 4.45266 16.9445 5.83337C16.9445 7.21409 15.8252 8.33337 14.4445 8.33337C13.0638 8.33337 11.9445 7.21409 11.9445 5.83337ZM14.4445 5.00004C13.9842 5.00004 13.6111 5.37314 13.6111 5.83337C13.6111 6.29361 13.9842 6.66671 14.4445 6.66671C14.9047 6.66671 15.2778 6.29361 15.2778 5.83337C15.2778 5.37314 14.9047 5.00004 14.4445 5.00004Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4445 8.88893C13.9842 8.88893 13.6111 9.26203 13.6111 9.72226C13.6111 10.1825 13.9842 10.5556 14.4445 10.5556H15.2778C16.0449 10.5556 16.6667 11.1774 16.6667 11.9445V13.6112C16.6667 14.0714 17.0398 14.4445 17.5 14.4445C17.9603 14.4445 18.3334 14.0714 18.3334 13.6112V11.9445C18.3334 10.2569 16.9653 8.88893 15.2778 8.88893H14.4445Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38891 9.72226C6.38891 9.26203 6.01581 8.88893 5.55558 8.88893H4.72224C3.03471 8.88893 1.66669 10.2569 1.66669 11.9445V13.6112C1.66669 14.0714 2.03978 14.4445 2.50002 14.4445C2.96026 14.4445 3.33335 14.0714 3.33335 13.6112V11.9445C3.33335 11.1774 3.95518 10.5556 4.72224 10.5556H5.55558C6.01581 10.5556 6.38891 10.1825 6.38891 9.72226Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 12.2223C12.5209 12.2223 13.8889 13.5903 13.8889 15.2778V16.3889C13.8889 16.8492 13.5158 17.2223 13.0555 17.2223C12.5953 17.2223 12.2222 16.8492 12.2222 16.3889V15.2778C12.2222 14.5108 11.6004 13.8889 10.8333 13.8889H9.16667C8.39954 13.8889 7.77778 14.5107 7.77778 15.2777V16.3889C7.77778 16.8492 7.40469 17.2223 6.94445 17.2223C6.48421 17.2223 6.11112 16.8492 6.11112 16.3889V15.2777C6.11112 13.5901 7.4792 12.2223 9.16667 12.2223H10.8333Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15986_21662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmployed);
export default __webpack_public_path__ + "static/media/iconEmployed.57b5a30244e43be060cfa80ec9f61ec4.svg";
export { ForwardRef as ReactComponent };